import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { ConnectedPageWithTable } from '../root_classes/connected-page-with-table';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent extends ConnectedPageWithTable implements OnInit {

	public userRole: string = "";
	public stateChoice: any[] = [];

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);

		// Creating filter list.
		this.stateChoice = [
			{label: "En attente", value:'D'},
			{label: "En cours", value:'R'},
			{label: "Terminé", value:'E'},
			{label: "Désactivé", value:'X'}
		];
	}

	ngOnInit(): void {
		this.userRole = this.cookieService.get(this.constantsModule.cookieRole);

		if ("A" == this.userRole) {
			this.setColumns([
				{field:"name", header:"Nom", sort:"name"},
				{field:"state", header:"Etat", sort:"state"},
				{field:"path", header:"Chemin", sort:"path"},
				{field:"nb_files", header:"Nombre de fichiers", sort:"nb_files"},
				{field:"endDateVal", header:"Date d'arrêt", sort:"endDateVal"},
			]);
		} else {
			this.setColumns([
				{field:"name", header:"Nom", sort:"name"},
				{field:"nb_files", header:"Nombre de fichiers", sort:"nb_files"},
				{field:"endDateVal", header:"Date d'arrêt", sort:"endDateVal"}
			]);
		}

		// Loadint data from the server.
		this.loadData("/api/user-list-folder");
  }

  public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}
}
